import { render, staticRenderFns } from "./thankYouPage.vue?vue&type=template&id=648ab6ca&scoped=true"
import script from "./thankYouPage.vue?vue&type=script&lang=js"
export * from "./thankYouPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ab6ca",
  null
  
)

export default component.exports